import { formatRp, itemCost, jobCost } from "../lib/constants";

export const CostSummary = ({ open, jobs, onClose }) => {
  if (!open) return null;

  const allCosts = jobs.flatMap((j) => j.items.flatMap((it) => it.costs || []));
  const totalJasa = allCosts.filter((c) => c.type === "jasa").reduce((s, c) => s + (c.price || 0) * (c.qty || 0), 0);
  const totalBahan = allCosts.filter((c) => c.type === "bahan").reduce((s, c) => s + (c.price || 0) * (c.qty || 0), 0);
  const grand = totalJasa + totalBahan;

  return (
    <div className="no-print fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl my-auto flex flex-col max-h-[92vh] animate-fade-up" data-testid="cost-summary-modal">
        <div className="px-6 py-4 bg-gradient-to-r from-slate-900 to-teal-800 text-white flex justify-between items-center">
          <h3 className="text-base sm:text-lg font-bold flex items-center gap-2"><i className="ph-bold ph-calculator text-teal-300" /> Rekap Estimasi Biaya</h3>
          <button onClick={onClose} className="text-slate-300 hover:text-white p-1 rounded-lg hover:bg-white/10"><i className="ph-bold ph-x text-xl" /></button>
        </div>
        <div className="p-6 overflow-y-auto space-y-4">
          <p className="text-xs text-slate-500">Menghitung {jobs.length} pekerjaan sesuai filter yang aktif.</p>
          <div className="border border-slate-200 rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead><tr className="bg-slate-50 text-slate-600 text-xs uppercase font-bold">
                <th className="text-left p-3">Lokasi</th><th className="text-left p-3">Pekerjaan</th><th className="text-right p-3">Estimasi</th>
              </tr></thead>
              <tbody className="divide-y divide-slate-100">
                {jobs.map((j) => (
                  <tr key={j.id} data-testid={`cost-row-${j.id}`}>
                    <td className="p-3 text-slate-600">{j.location_name}</td>
                    <td className="p-3 font-semibold text-slate-800">{j.title}</td>
                    <td className="p-3 text-right font-mono font-bold text-slate-800">{formatRp(jobCost(j))}</td>
                  </tr>
                ))}
                {jobs.length === 0 && <tr><td colSpan={3} className="p-4 text-center text-slate-400 text-xs">Tidak ada data.</td></tr>}
              </tbody>
            </table>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="p-3 rounded-xl bg-teal-50 border border-teal-200"><p className="text-[11px] font-bold text-teal-700 uppercase">Total Jasa</p><p className="font-mono font-extrabold text-teal-800 mt-1">{formatRp(totalJasa)}</p></div>
            <div className="p-3 rounded-xl bg-amber-50 border border-amber-200"><p className="text-[11px] font-bold text-amber-700 uppercase">Total Bahan</p><p className="font-mono font-extrabold text-amber-800 mt-1">{formatRp(totalBahan)}</p></div>
            <div className="p-3 rounded-xl bg-slate-900 text-white"><p className="text-[11px] font-bold text-teal-300 uppercase">Grand Total</p><p className="font-mono font-extrabold mt-1" data-testid="cost-grand-total">{formatRp(grand)}</p></div>
          </div>
        </div>
      </div>
    </div>
  );
};
